export default __webpack_public_path__ + "static/Roobert-Bold-81d66e1539eabdef26990c562762a463.eot";